module.exports = __webpack_public_path__ + "static/media/resources.7727697f.svg";